import Rodape from "../../components/rodape";
import BannerProjects from "../../components/bannerProjects";
import BusinessOtimize from "../../components/businessOtimize";
import AccordionInnovation from "../../components/accordionInnovation";
import EvolucaoMigracao from "../../components/EvolucaoMigracao";
import MigracaoBeneficios from "../../components/migracaoBeneficios";

function Migracao() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-migracao.png"
                title="/MIGRAÇÃO E"
                titleBold="MODERNIZAÇÃO"
                iconSrc="../assets/icone-projectiva-nex2ai.png"
                iconAlt="Projectiva Nex2AI"
                iconText="nex"
                iconTextBold="2ai"
                descriptionBold=""
                description={
                    <>
                        Otimização de custos e aumento da eficiência
                        transformando sistemas legados em{" "}
                        <span className="font-titillium-web-bold">
                            soluções flexíveis e escaláveis
                        </span>
                        . Faça a migração e modernização para nuvem e{" "}
                        <span className="font-titillium-web-bold">
                            avance seu negócio e sua eficiência.
                        </span>
                    </>
                }
                footerText="VERTICAL INNOVATION | Cloud"
                buttonText="Quero me conectar"
                buttonColor="from-[#FC0021] via-[#FC0021] to-[#5534D9]"
                brand="nex2ai"
            />
            <EvolucaoMigracao />
            <AccordionInnovation
                title={
                    <>
                        Migração
                        <br />
                        para a nuvem
                    </>
                }
                description="Envolve a transferência de aplicativos, dados e ativos digitais para a infraestrutura de nuvem, com várias abordagens disponíveis, sendo elas:"
                imageSrc="/assets/migracao-nuvem.png"
                imageAlt="Práticas FinOps"
                items={[
                    {
                        id: "01",
                        title: "LIFT AND SHIFT",
                        description:
                            "Transferência rápida de aplicativos para a nuvem com mínimas alterações, ideal para quem busca agilidade e custo reduzido.",
                    },
                    {
                        id: "02",
                        title: "REFATORAÇÃO",
                        description:
                            "Adaptamos seus aplicativos para aproveitar ao máximo os recursos da nuvem, como escalabilidade automática e eficiência.",
                    },
                    {
                        id: "03",
                        title: "REPLATAFORMA",
                        description:
                            "Migramos seus aplicativos para plataformas mais modernas, como containers ou serviços gerenciados na nuvem.",
                    },
                    {
                        id: "04",
                        title: "ARQUITETURA NATIVA NA NUVEM",
                        description:
                            "Recriamos seus aplicativos para operar nativamente na nuvem, utilizando arquiteturas avançadas como microserviços e serverless.",
                    },
                ]}
            />
            <AccordionInnovation
                title={
                    <>
                        Modernização
                        <br />
                        da Nuvem
                    </>
                }
                description="Foca na atualização de aplicativos e infraestrutura legados para soluções tecnológicas de alta performance, incluindo:"
                imageSrc="/assets/migracao-modernizacao.png"
                items={[
                    {
                        id: "01",
                        title: "MICROSERVIÇOS",
                        description:
                            "Dividimos aplicativos grandes em componentes menores e mais flexíveis, facilitando a escalabilidade e a manutenção.",
                    },
                    {
                        id: "02",
                        title: "CONTAINERS",
                        description:
                            "Utilizamos containers para melhorar a portabilidade e a consistência de seus aplicativos em diferentes ambientes.",
                    },
                    {
                        id: "03",
                        title: "DEVOPS E AUTOMAÇÃO",
                        description:
                            "Implementamos práticas de DevOps para acelerar o ciclo de desenvolvimento e entrega contínua de software.",
                    },
                    {
                        id: "04",
                        title: "IA E MACHINE LEANING",
                        description:
                            "Integramos inteligência artificial para aprimorar a automação e a análise de dados em tempo real.",
                    },
                    {
                        id: "05",
                        title: "SERVIÇOS GERENCIADOS",
                        description:
                            "Migramos para serviços gerenciados que reduzem a carga de manutenção e permitem que sua equipe foque no core business.",
                    },
                ]}
            />
            <MigracaoBeneficios
                servicosData={[
                    {
                        icon: "../assets/servicos/escalabilidade_icon.svg",
                        iconHover: "../assets/servicos/escalabilidade_icon.svg",
                        title: "Escalabilidade",
                        text: (
                            <>
                                Otimize sua capacidade de aumentar ou diminuir
                                recursos de acordo com a demanda.
                            </>
                        ),
                        glowColor: "#FC0021",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/reducao_custos_icon.svg",
                        iconHover: "../assets/servicos/reducao_custos_icon.svg",
                        title: "Redução de Custos",
                        text: (
                            <>
                                Pague apenas pelos recursos utilizados,
                                eliminando a necessidade de grandes
                                investimentos em hardware.
                            </>
                        ),
                        glowColor: "#FC0021",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/inovacao_icon.svg",
                        iconHover: "../assets/servicos/inovacao_icon.svg",
                        title: "Inovação Acelerada",
                        text: (
                            <>
                                Obtenha acesso a tecnologias e serviços modernos
                                e avançados, fornecidos pelos provedores de
                                nuvem.
                            </>
                        ),
                        glowColor: "#FC0021",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/resiliencia_icon.svg",
                        iconHover: "../assets/servicos/resiliencia_icon.svg",
                        title: "Resiliência e Recuperação",
                        text: (
                            <>
                                Tenha uma implementação mais fácil e ágil das
                                melhores práticas de segurança e recuperação de
                                desastres com as soluções na nuvem.
                            </>
                        ),
                        glowColor: "#FC0021",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/agilidade2_icon.svg",
                        iconHover: "../assets/servicos/agilidade2_icon.svg",
                        title: "Agilidade",
                        text: (
                            <>
                                Melhore sua capacidade de adaptação rápida às
                                mudanças de mercado e aos requisitos dos seus
                                clientes.
                            </>
                        ),
                        glowColor: "#FC0021",
                        url: "",
                    },
                ]}
                title="Benefícios"
            />
            <BusinessOtimize
                title={
                    <>
                        <span className="font-inter-bold">
                            Modernize sua infraestrutura com eficiência e
                            agilidade
                        </span>
                        <br />e obtenha os benefícios das soluções na nuvem.
                    </>
                }
                buttonText={
                    <>
                        <span className="font-inter-medium bg-white text-[#FC0021] relative">
                            Otimize seu negócio{" "}
                        </span>
                    </>
                }
                backgroundImage="../assets/next2ai_background.png"
                buttonLink="/"
            />
            <Rodape />
        </>
    );
}

export default Migracao;
